module.exports = __webpack_public_path__ + "img/toBeDealImg.c8cc1726.svg";